module.exports = __webpack_public_path__ + "img/ts2.2ccf78b9.png";